import { useCurrentUser, useIsLoggedIn } from '../context/hooks';
import { useEffect } from 'react';
import { SocketModule } from '../modules/Socket.module';
import Cookies from 'js-cookie';
import { COOKIE_NAMES } from '../constants';

const SocketService = () => {
  const isLoggedIn = useIsLoggedIn();
  const user = useCurrentUser();
  useEffect(() => {
    if (isLoggedIn) {
      console.log('Socket', 'init');
      SocketModule.init(user!._id, Cookies.get(COOKIE_NAMES.COOKIE_ACCESS_TOKEN) || '');
    } else {
      SocketModule.cleanUp();
    }
  }, [isLoggedIn]);
  return null;
};

export default SocketService;
